import { Box, Grid, Stack } from '@mui/material'
import { Container, Typography } from '@evocolabs/orkaui'
import { useEffect, useRef } from 'react'

import AudiologistOrka64 from '@evocolabs/icons/lib/AudiologistOrka64'
import Calendar64 from '@evocolabs/icons/lib/Calendar64'
import Phone64 from '@evocolabs/icons/lib/Phone64'
import TimeCheck64 from '@evocolabs/icons/lib/TimeCheck64'
import { getImage } from '@/src/utils/media'
import styles from './styles.module.scss'

const SRC_PATH = 'website/orkaCare'
const data = {
  title: 'Comprehensive Care for Your Hearing Health',
  src: 'HeroSection_241212.jpg',
  coverRatio: { xs: 393 / 390, sm: 600 / 833, dl: 600 / 1440 }
}

const highlights: Array<{ Icon: JSX.Element; content: string }> = [
  { Icon: <Calendar64 />, content: 'Free Unlimited Consultation' },
  { Icon: <TimeCheck64 />, content: 'Real-time Adjustment' },
  {
    Icon: <AudiologistOrka64 />,
    content: 'Licensed Hearing Care Professionals'
  },
  { Icon: <Phone64 />, content: 'Orka Health App' }
]
const responsiveOrder = [1, 3, 2, 4] // swap the position of 2nd and 3rd element
const Highlights = (): JSX.Element => (
  <Box
    padding={{ xs: '24px 16px', sm: '40px' }}
    className={styles['banner-highlights-content-wrapper']}
  >
    {highlights.map(({ Icon, content }, index) => (
      <Grid
        columns={{ xs: 6, sm: 6, dl: 3 }}
        key={content}
        order={{
          xs: responsiveOrder[index],
          dl: index + 1
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          height="100%"
          alignItems="center"
        >
          {Icon}
          <Typography
            variant="Body1"
            ml={1}
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            {content}
          </Typography>
        </Stack>
      </Grid>
    ))}
  </Box>
)

const getPaddingBottom = () => {
  const { coverRatio } = data
  return Object.keys(coverRatio).reduce((result, key) => {
    result[key] = `${coverRatio[key] * 100}%`
    return result
  }, {})
}

const Banner = ({
  storedHeight,
  onResize
}: {
  storedHeight: number
  onResize: (number) => void
}) => {
  const ref = useRef(null)

  useEffect(() => {
    if (!ref.current) return

    const handleResize = () => {
      const currentRefHeight = ref.current.clientHeight
      if (currentRefHeight !== storedHeight) {
        onResize(currentRefHeight)
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Box className={styles.banner} mt={{ dl: -12 }}>
      <Box
        className={styles['banner-image-wrapper']}
        sx={{
          background: `url(${getImage(
            data.src,
            'PC',
            SRC_PATH
          )}) no-repeat center center`,
          paddingBottom: getPaddingBottom(),
          position: 'relative'
        }}
      >
        <Box className={styles['banner-container']}>
          <Container
            sx={{
              transform: {
                xs: `translateY(-50px)`,
                md: `translateY(20px)`
              }
            }}
          >
            <Typography variant="h2" className={styles.text}>
              {data.title}
            </Typography>
          </Container>
        </Box>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          transform: {
            xs: `translateY(-80px)`,
            md: 'translateY(-50%)'
          }
        }}
        ref={ref}
      >
      </Box>
    </Box>
  )
}

export default Banner
